import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { updateBuilding } from 'src/redux-store/slices/constructionFormSlice';
import Signature from 'src/ui-component/Signature';
import { handleInsertSubcodeDocs } from '../uploadSubcodeDocs';

const PermitFeeSummary = () => {
  const dispatch = useDispatch();

  const data = useSelector(
    (state: RootState) => state.constructionFormSlice?.Building?.getAllFee
  );

  const DefaultUrl = useSelector(
    (state: RootState) => state.constructionFormSlice?.Building?.SignatureImage
  );

  const calculatedTotalFee = data?.summary?.reduce((total, item) => {
    return total + (item['Final Fee'] ? Number(item['Final Fee']) : 0);
  }, 0);

  const getAdditionalInfo = (item) => {
    return Object.keys(item).filter(
      (key) =>
        key !== 'Item' &&
        key !== 'Final Fee' &&
        key !== 'check' &&
        key !== 'item' &&
        item[key] !== null
    );
  };

  const getSignature = async (signature: {
    imageURL: string;
    file: { name: string };
  }) => {
    if (signature?.file) {
      const FileData = await handleInsertSubcodeDocs(
        signature.file,
        'Construction',
        'Building'
      );
      dispatch(updateBuilding({ SignatureImage: FileData?.DownloadURL }));
    }
  };

  return (
    data && (
      <Box sx={{ margin: 'auto' }}>
        <Card elevation={4}>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
                flexDirection: { xs: 'column', sm: 'row', md: 'row' }
              }}
            >
              <Typography variant="h5" component="h1">
                Permit Fee Summary
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <TableContainer component={Paper} sx={{ mb: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell>Details</TableCell>
                    <TableCell align="right">Fees</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.summary.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {item?.Item}
                      </TableCell>
                      <TableCell>
                        {getAdditionalInfo(item).map((key, idx) => (
                          <Box key={idx} sx={{ fontSize: 'small' }}>
                            <Typography
                              variant="body2"
                              component="span"
                              fontWeight="medium"
                            >
                              {key}:{' '}
                            </Typography>
                            {item[key]}
                          </Box>
                        ))}
                      </TableCell>
                      <TableCell align="right">
                        {item['Final Fee'] !== null
                          ? `$${Number(item['Final Fee']).toLocaleString()}`
                          : 'Pending'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                bgcolor: 'grey.200',
                p: 2,
                borderRadius: 1
              }}
            >
              <Typography variant="h6">Total Subcode Fees</Typography>
              <Typography variant="h6" color="success.main">
                ${calculatedTotalFee.toLocaleString()}
              </Typography>
            </Box>
          </CardContent>
          <Signature getSignature={getSignature} DefaultUrl={DefaultUrl} />
        </Card>
      </Box>
    )
  );
};

export default PermitFeeSummary;
